import { ICompany } from '@partiu/api/types';
import { HStack, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { FaCircle } from 'react-icons/fa6';

export function AgreementCompanyStatus({ company }: { company: ICompany }) {
  const translations: Record<string, { icon: JSX.Element; text: string }> = {
    'pending-approval': {
      icon: <FaCircle color="yellow" />,
      text: 'Pendente de aprovação pela Partiu.',
    },
    denied: {
      icon: <FaCircle color="red" />,
      text: 'Negado pela Partiu, entre em contato com o suporte.',
    },
    'pending-terms': {
      icon: <FaCircle color="orange" />,
      text: 'Pendente de aprovação dos termos de uso pelo lojista.',
    },
    'pending-training': {
      icon: <FaCircle color="blue" />,
      text: 'Pendente de treinamento pela Partiu',
    },
    approved: {
      icon: <FaCircle color="green" />,
      text: 'Aprovado, já disponível no app e landing.',
    },
  };

  const data: { icon: JSX.Element; text: string } = useMemo(() => translations[company.status], [company]);

  return (
    <HStack>
      {data.icon}
      <Text>{data.text}</Text>
    </HStack>
  );
}
